import { ALLOW_ALL } from '$lib/services/auth/policies';
import { ROUTE_TO_NMHP_HANDLER } from '$lib/services/auth/policy-exception-handler';

export const policy = ALLOW_ALL;
export const policyExceptionHandler = ROUTE_TO_NMHP_HANDLER;
